"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreemApiWebhookEventPayloadToJSON = exports.StreemApiWebhookEventPayloadFromJSONTyped = exports.StreemApiWebhookEventPayloadFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function StreemApiWebhookEventPayloadFromJSON(json) {
    return StreemApiWebhookEventPayloadFromJSONTyped(json, false);
}
exports.StreemApiWebhookEventPayloadFromJSON = StreemApiWebhookEventPayloadFromJSON;
function StreemApiWebhookEventPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'roomCreated': !(0, runtime_1.exists)(json, 'room_created') ? undefined : (0, _1.StreemApiEventsRoomCreatedFromJSON)(json['room_created']),
        'roomUpdated': !(0, runtime_1.exists)(json, 'room_updated') ? undefined : (0, _1.StreemApiEventsRoomUpdatedFromJSON)(json['room_updated']),
        'roomArchived': !(0, runtime_1.exists)(json, 'room_archived') ? undefined : (0, _1.StreemApiEventsRoomArchivedFromJSON)(json['room_archived']),
        'roomParticipantCreated': !(0, runtime_1.exists)(json, 'room_participant_created') ? undefined : (0, _1.StreemApiEventsRoomParticipantCreatedFromJSON)(json['room_participant_created']),
        'roomParticipantUpdated': !(0, runtime_1.exists)(json, 'room_participant_updated') ? undefined : (0, _1.StreemApiEventsRoomParticipantUpdatedFromJSON)(json['room_participant_updated']),
        'groupReservationCreated': !(0, runtime_1.exists)(json, 'group_reservation_created') ? undefined : (0, _1.StreemApiEventsGroupReservationCreatedFromJSON)(json['group_reservation_created']),
        'groupReservationUpdated': !(0, runtime_1.exists)(json, 'group_reservation_updated') ? undefined : (0, _1.StreemApiEventsGroupReservationUpdatedFromJSON)(json['group_reservation_updated']),
        'groupWaitTimeUpdated': !(0, runtime_1.exists)(json, 'group_wait_time_updated') ? undefined : (0, _1.StreemApiEventsGroupWaitTimeUpdatedFromJSON)(json['group_wait_time_updated']),
        'artifactCreated': !(0, runtime_1.exists)(json, 'artifact_created') ? undefined : (0, _1.StreemApiEventsArtifactCreatedFromJSON)(json['artifact_created']),
        'artifactUpdated': !(0, runtime_1.exists)(json, 'artifact_updated') ? undefined : (0, _1.StreemApiEventsArtifactUpdatedFromJSON)(json['artifact_updated']),
        'artifactDeleted': !(0, runtime_1.exists)(json, 'artifact_deleted') ? undefined : (0, _1.StreemApiEventsArtifactDeletedFromJSON)(json['artifact_deleted']),
        'roomNoteCreated': !(0, runtime_1.exists)(json, 'room_note_created') ? undefined : (0, _1.StreemApiEventsRoomNoteCreatedFromJSON)(json['room_note_created']),
        'roomNoteUpdated': !(0, runtime_1.exists)(json, 'room_note_updated') ? undefined : (0, _1.StreemApiEventsRoomNoteUpdatedFromJSON)(json['room_note_updated']),
        'roomNoteDeleted': !(0, runtime_1.exists)(json, 'room_note_deleted') ? undefined : (0, _1.StreemApiEventsRoomNoteDeletedFromJSON)(json['room_note_deleted']),
        'roomNoteFinalized': !(0, runtime_1.exists)(json, 'room_note_finalized') ? undefined : (0, _1.StreemApiEventsRoomNoteFinalizedFromJSON)(json['room_note_finalized']),
    };
}
exports.StreemApiWebhookEventPayloadFromJSONTyped = StreemApiWebhookEventPayloadFromJSONTyped;
function StreemApiWebhookEventPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'room_created': (0, _1.StreemApiEventsRoomCreatedToJSON)(value.roomCreated),
        'room_updated': (0, _1.StreemApiEventsRoomUpdatedToJSON)(value.roomUpdated),
        'room_archived': (0, _1.StreemApiEventsRoomArchivedToJSON)(value.roomArchived),
        'room_participant_created': (0, _1.StreemApiEventsRoomParticipantCreatedToJSON)(value.roomParticipantCreated),
        'room_participant_updated': (0, _1.StreemApiEventsRoomParticipantUpdatedToJSON)(value.roomParticipantUpdated),
        'group_reservation_created': (0, _1.StreemApiEventsGroupReservationCreatedToJSON)(value.groupReservationCreated),
        'group_reservation_updated': (0, _1.StreemApiEventsGroupReservationUpdatedToJSON)(value.groupReservationUpdated),
        'group_wait_time_updated': (0, _1.StreemApiEventsGroupWaitTimeUpdatedToJSON)(value.groupWaitTimeUpdated),
        'artifact_created': (0, _1.StreemApiEventsArtifactCreatedToJSON)(value.artifactCreated),
        'artifact_updated': (0, _1.StreemApiEventsArtifactUpdatedToJSON)(value.artifactUpdated),
        'artifact_deleted': (0, _1.StreemApiEventsArtifactDeletedToJSON)(value.artifactDeleted),
        'room_note_created': (0, _1.StreemApiEventsRoomNoteCreatedToJSON)(value.roomNoteCreated),
        'room_note_updated': (0, _1.StreemApiEventsRoomNoteUpdatedToJSON)(value.roomNoteUpdated),
        'room_note_deleted': (0, _1.StreemApiEventsRoomNoteDeletedToJSON)(value.roomNoteDeleted),
        'room_note_finalized': (0, _1.StreemApiEventsRoomNoteFinalizedToJSON)(value.roomNoteFinalized),
    };
}
exports.StreemApiWebhookEventPayloadToJSON = StreemApiWebhookEventPayloadToJSON;
//# sourceMappingURL=StreemApiWebhookEventPayload.js.map